import _ from 'lodash';

import {
  RESET_USER_PERMIT,
  GET_USER_PERMITS_REQUEST,
  GET_USER_PERMITS_SUCCESS,
  GET_USER_PERMITS_ERROR,
  GET_SINGLE_PERMIT_REQUEST,
  GET_SINGLE_PERMIT_SUCCESS,
  GET_SINGLE_PERMIT_ERROR,
  UPDATE_SINGLE_USER_PERMIT,
  UPDATE_SINGLE_PERMIT_ERROR,
  UPDATE_SINGLE_PERMIT_REQUEST,
  UPDATE_SINGLE_PERMIT_SUCCESS,
  UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_ERROR,
  UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_REQUEST,
  UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_SUCCESS,
  ADD_SINGLE_PERMIT_VEHICLE_ERROR,
  ADD_SINGLE_PERMIT_VEHICLE_REQUEST,
  ADD_SINGLE_PERMIT_VEHICLE_SUCCESS,
  UPDATE_SINGLE_PERMIT_VEHICLE_ERROR,
  UPDATE_SINGLE_PERMIT_VEHICLE_REQUEST,
  UPDATE_SINGLE_PERMIT_VEHICLE_SUCCESS,
  REMOVE_SINGLE_PERMIT_VEHICLE_ERROR,
  REMOVE_SINGLE_PERMIT_VEHICLE_REQUEST,
  REMOVE_SINGLE_PERMIT_VEHICLE_SUCCESS,
} from '../actions/types';

const defaultState = {
  permits: [],
  isLoadingSinglePermit: false,
  isUpdatingSinglePermit: false,
  isLoading: false,
  userPermit: {},
  error: '',
};

/**
 * User's permit object reducer logic.
 * @param {Object} state - The state for this reducer in Redux.
 * @param {Object} action - The action which details what to do & what state to update.
 * @returns {Object} - Newly created state object.
 */
export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_USER_PERMITS_REQUEST:
      return { ...state, isLoading: true };
    case GET_USER_PERMITS_SUCCESS:
      return { ...state, permits: action.payload, isLoading: false };
    case GET_USER_PERMITS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case GET_SINGLE_PERMIT_REQUEST:
      return {
        ...state,
        isLoadingSinglePermit: true,
      };
    case GET_SINGLE_PERMIT_SUCCESS:
      return {
        ...state,
        isLoadingSinglePermit: false,
        userPermit: action.payload,
      };
    case GET_SINGLE_PERMIT_ERROR:
      return {
        ...state,
        userPermit: null,
        isLoadingSinglePermit: false,
        error: action.payload,
      };
    case RESET_USER_PERMIT:
      return {
        ...state,
        userPermit: {},
        isLoadingSinglePermit: false,
        error: '',
      };
    case UPDATE_SINGLE_PERMIT_ERROR:
    case UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_ERROR:
    case ADD_SINGLE_PERMIT_VEHICLE_ERROR:
    case UPDATE_SINGLE_PERMIT_VEHICLE_ERROR:
    case REMOVE_SINGLE_PERMIT_VEHICLE_ERROR:
      return {
        ...state,
        error: action.payload,
        isUpdatingSinglePermit: false,
      };
    case UPDATE_SINGLE_PERMIT_REQUEST:
    case UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_REQUEST:
    case ADD_SINGLE_PERMIT_VEHICLE_REQUEST:
    case UPDATE_SINGLE_PERMIT_VEHICLE_REQUEST:
    case REMOVE_SINGLE_PERMIT_VEHICLE_REQUEST:
      return {
        ...state,
        isUpdatingSinglePermit: true,
      };
    case UPDATE_SINGLE_PERMIT_SUCCESS:
      return {
        ...state,
        isUpdatingSinglePermit: false,
        userPermit: {
          ..._.merge(state.userPermit, action.payload),
          auto_renew_card: _.get(action.payload, 'auto_renew_card', null),
          auto_renew_days_before: _.get(action.payload, 'auto_renew_days_before', null),
        },
      };
    case UPDATE_SINGLE_PERMIT_HOLDER_AND_VEHICLES_SUCCESS:
      return {
        ...state,
        isUpdatingSinglePermit: false,
        userPermit: {
          ...state.userPermit,
          fields: action.payload.fields,
          vehicles: action.payload.vehicles,
          documents: action.payload.documents,
        },
      };
    case ADD_SINGLE_PERMIT_VEHICLE_SUCCESS:
      return {
        ...state,
        isUpdatingSinglePermit: false,
        userPermit: {
          ...state.userPermit,
          vehicles: [
            ...state.userPermit.vehicles,
            ...(_.findIndex(state.userPermit.vehicles, vehicle => (
              vehicle.id === action.payload.id
            )) === -1 ? [action.payload] : []),
          ],
        },
      };
    case UPDATE_SINGLE_PERMIT_VEHICLE_SUCCESS:
      return {
        ...state,
        isUpdatingSinglePermit: false,
        userPermit: {
          ...state.userPermit,
          vehicles: [
            ..._.map(state.userPermit.vehicles, vehicle => (
              vehicle.id === action.payload.id ? action.payload : vehicle
            )),
          ],
        },
      };
    case REMOVE_SINGLE_PERMIT_VEHICLE_SUCCESS:
      return {
        ...state,
        isUpdatingSinglePermit: false,
        userPermit: {
          ...state.userPermit,
          vehicles: _.filter(state.userPermit.vehicles, vehicle => (
            vehicle.id !== action.payload.id
          )),
        },
      };
    case UPDATE_SINGLE_USER_PERMIT:
      return {
        ...state,
        userPermit: {
          ..._.merge(state.userPermit, action.payload),
        },
      };
    default:
      return state;
  }
};
